import { useMemo } from 'react';
import * as React from 'react';

import BicycleNumber from '@/components/elements/Icon/BicycleNumber';
import Dokanto4TwoSetNumber from '@/components/elements/Icon/Dokanto4TwoSetNumber';
import { MultiraceRefund, MultiraceType } from '@/lib/apollo/types/gen/graphql';

import { OtherData } from '../style';
import {
  Amount,
  AmountWrapper,
  HitCount,
  HitNums,
  Refunds,
  RefundWrapper,
  TableData,
} from './style';

interface RefundDataProps {
  isCanceled: boolean;
  isCompleted: boolean;
  isSpecialPayment: boolean;
  unitOfRelease: number;
  multiraceRefunds: MultiraceRefund[];
  multiraceType: MultiraceType;
}

const RefundData: React.FC<RefundDataProps> = ({
  isCanceled,
  isCompleted,
  isSpecialPayment,
  unitOfRelease,
  multiraceRefunds,
  multiraceType,
}) => {
  const is4Two = useMemo(
    () => multiraceType === MultiraceType.Dokanto4two,
    [multiraceType],
  );

  const calculatedAmount = (amount: number) =>
    useMemo(() => (Math.floor(amount / 10) * 10).toLocaleString(), [amount]);

  const hitBetCount = (mr: MultiraceRefund) =>
    useMemo(() => mr.hitCount / unitOfRelease, [mr, unitOfRelease]);

  if (isCanceled || !isCompleted) {
    return <OtherData>-</OtherData>;
  }

  if (isSpecialPayment) {
    return <OtherData>特払い</OtherData>;
  }

  return (
    <>
      {multiraceRefunds.length ? (
        <>
          {multiraceRefunds.length === 1 ? (
            <OtherData>
              {multiraceRefunds[0].hitCount > 0
                ? `${calculatedAmount(multiraceRefunds[0].amount)}円`
                : '-'}
            </OtherData>
          ) : (
            <TableData>
              <Refunds>
                {multiraceRefunds.map(mr => (
                  <RefundWrapper key={`refund-${mr.hitNumbers.join('')}`}>
                    <HitNums is4Two={is4Two}>
                      {mr.hitNumbers.map((num, i) => (
                        <React.Fragment key={`frag-${num}-${i}`}>
                          {is4Two ? (
                            <Dokanto4TwoSetNumber number={num} />
                          ) : (
                            <BicycleNumber
                              bicycleNum={num}
                              key={`bicycleNum-${num}-${i}`}
                            >
                              {num}
                            </BicycleNumber>
                          )}
                        </React.Fragment>
                      ))}
                    </HitNums>
                    <AmountWrapper>
                      <HitCount>{hitBetCount(mr)}口</HitCount>
                      <Amount>{calculatedAmount(mr.amount)}円</Amount>
                    </AmountWrapper>
                  </RefundWrapper>
                ))}
              </Refunds>
            </TableData>
          )}
        </>
      ) : (
        <OtherData>-</OtherData>
      )}
    </>
  );
};

export default RefundData;
